import { darken } from "@theme-ui/color"

export default {
  root: {
    color: "text",
    fontFamily: "body",
    lineHeight: "body",
    fontWeight: "body",
    overflowX: "hidden",
    "* > ::selection": {
      bg: "primary",
      color: "background",
    },
  },
  h1: {
    color: "dark",
    fontFamily: "heading",
    lineHeight: "heading",
    fontWeight: "heading",
    fontSize: [4, 6, 7],
  },
  h2: {
    color: "dark",
    fontFamily: "heading",
    lineHeight: "heading",
    mt: 4,
    mb: 3,
    fontWeight: "heading",
    fontSize: [4, 5, 6],
  },
  h3: {
    color: "dark",
    fontFamily: "heading",
    lineHeight: "heading",
    mt: 3,
    mb: 2,
    fontWeight: "heading",
    fontSize: [3, 4, 5],
  },
  h4: {
    color: "dark",
    fontFamily: "heading",
    lineHeight: "heading",
    fontWeight: "heading",
    mt: 3,
    mb: 2,
    fontSize: [2, 3, 4],
  },
  h5: {
    color: "dark",
    fontFamily: "heading",
    lineHeight: "heading",
    fontWeight: "heading",
    mt: 2,
    mb: 1,
    fontSize: [1, 2, 3],
  },
  h6: {
    color: "dark",
    fontFamily: "heading",
    lineHeight: "heading",
    fontWeight: "heading",
    mt: 2,
    mb: 1,
    fontSize: [0, 1, 2],
  },
  p: {
    fontFamily: "body",
    fontWeight: "body",
    fontSize: [2, 3, 3],
    lineHeight: "body",
    mb: 3,
  },
  a: {
    color: "primary",
    fontWeight: "bold",
    "&:visited": {
      color: darken("primary", 0.1),
    },
    "&:hover": {
      textDecoration: "none",
    },
  },
  img: {
    maxWidth: "100%",
  },
  blockquote: {
    bg: "primary",
    borderRadius: "default",
    color: "background",
    my: 4,
    mx: 0,
    p: 4,
    position: "relative",
    "&>p": {
      fontSize: [3, 3, 4],
      "&:first-child": {
        mt: 0,
      },
      "&:last-child": {
        mb: 0,
      },
    },
    "&:before,&:after": {
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      content: '""',
      display: "block",
      height: "3.5rem",
      position: "absolute",
      width: "3.5rem",
    },
    "&:before": {
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='50' height='38' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 38V27.547c0-3.085.584-6.333 1.752-9.745 1.169-3.411 2.793-6.678 4.875-9.8 2.08-3.12 4.527-5.788 7.338-8.002l8.105 5.77a63.047 63.047 0 0 0-5.695 10.127c-1.57 3.52-2.355 7.35-2.355 11.487V38H0zm27.93 0V27.547c0-3.085.584-6.333 1.752-9.745 1.169-3.411 2.793-6.678 4.874-9.8 2.082-3.12 4.528-5.788 7.339-8.002L50 5.77a63.047 63.047 0 0 0-5.696 10.127c-1.57 3.52-2.354 7.35-2.354 11.487V38H27.93z' fill='%236B181A'/%3E%3C/svg%3E")`,
      backgroundPosition: "top",
      left: 3,
      top: -3,
    },
    "&:after": {
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='50' height='38' viewBox='0 0 50 38' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M50 0L50 10.4527C50 13.5377 49.4158 16.7861 48.2475 20.1977C47.0792 23.6094 45.4545 26.8758 43.3735 29.9971C41.2924 33.1184 38.8463 35.7861 36.035 38L27.9299 32.2292C30.157 28.9991 32.0555 25.6237 33.6254 22.1032C35.1953 18.5826 35.9803 14.7536 35.9803 10.616L35.9803 -1.22564e-06L50 0ZM22.0701 -2.44171e-06L22.0701 10.4527C22.0701 13.5377 21.4859 16.7861 20.3176 20.1977C19.1493 23.6094 17.5246 26.8758 15.4436 29.9971C13.3625 33.1184 10.9164 35.7861 8.10515 38L4.31919e-06 32.2292C2.22709 28.999 4.1256 25.6237 5.69551 22.1032C7.26543 18.5826 8.05039 14.7536 8.05039 10.616L8.05039 -3.66735e-06L22.0701 -2.44171e-06Z' fill='%236B181A'/%3E%3C/svg%3E%0A")`,
      backgroundPosition: "bottom",
      right: 3,
      bottom: -3,
    },
  },
}
